import { MarketplaceType } from '@/Enums';
import { useMpAccountOptions } from '@/Hooks/Options/useMpAccountOptions';

export const useUpdateByFileOptions = () => {
  const mpOptions = useMpAccountOptions([MarketplaceType.Amazon]);

  return {
    mpOptions,
  };
};
